export var RequiredPermission;
(function (RequiredPermission) {
    RequiredPermission["ReadData"] = "READ_DATA";
    RequiredPermission["ReadConfig"] = "READ_CONFIG";
    RequiredPermission["WriteConfig"] = "WRITE_CONFIG";
    RequiredPermission["ReadSettings"] = "READ_SETTINGS";
    RequiredPermission["WriteSettings"] = "WRITE_SETTINGS";
    RequiredPermission["CrossTenantAdmin"] = "CROSS_TENANT_ADMIN";
})(RequiredPermission || (RequiredPermission = {}));
export var TemperatureUnits;
(function (TemperatureUnits) {
    TemperatureUnits["Celsius"] = "Celsius";
    TemperatureUnits["Fahrenheit"] = "Fahrenheit";
})(TemperatureUnits || (TemperatureUnits = {}));
export var ThermostatAction;
(function (ThermostatAction) {
    ThermostatAction["Heat"] = "Heat";
    ThermostatAction["Cool"] = "Cool";
    ThermostatAction["Circulate"] = "Circulate";
})(ThermostatAction || (ThermostatAction = {}));
export var ThermostatSettingType;
(function (ThermostatSettingType) {
    ThermostatSettingType["Hold"] = "Hold";
    ThermostatSettingType["Scheduled"] = "Scheduled";
})(ThermostatSettingType || (ThermostatSettingType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Monday"] = "Monday";
    DayOfWeek["Tuesday"] = "Tuesday";
    DayOfWeek["Wednesday"] = "Wednesday";
    DayOfWeek["Thursday"] = "Thursday";
    DayOfWeek["Friday"] = "Friday";
    DayOfWeek["Saturday"] = "Saturday";
    DayOfWeek["Sunday"] = "Sunday";
})(DayOfWeek || (DayOfWeek = {}));
//# sourceMappingURL=graphqlClient.js.map